export const FEED_POSTER_SNAPBACK_TIMING = { duration: 180 } as const;
